webpackJsonp([75],{

/***/ 1374:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1375);


/***/ }),

/***/ 1375:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _datetime = __webpack_require__(212);

var _datetime2 = _interopRequireDefault(_datetime);

var _es = __webpack_require__(852);

var _es2 = _interopRequireDefault(_es);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_datetime2.default.lang('es', _es2.default);

/***/ })

},[1374]);


// WEBPACK FOOTER //
// app/datetime.es-59086fff477f3d29ebdb.js